import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { IconButton, Tooltip } from "@mui/material";
import { Chip } from "@mui/material";
import { FormControlLabel, Input } from "@mui/material";
import { InputAdornment } from "@mui/material";
import HorizontalLinearStepper from "../../components/steper/Steper";
import Button from "@mui/material/Button";
import FullFeaturedCrudGrid from "../../components/DataGrid/DataGrid";
import DeleteIcon from "@mui/icons-material/Delete";
import useSave from "../../Hooks/useSave";
import { SentimentSatisfied } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function NewProduct() {
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  const [value, setValue] = useState("Chocolate Rugalech");
  const [sizeValue, setSizeValue] = useState("");
  const [baseProduct, setBaseProduct] = useState({
    productCode: "",
    productName: "",
    productDescription: "",
    productUnitOfMeasure: "",
  });

  const [packaging, setPackaging] = useState([
    {
      productCode: "",
      productName: "",
      productDescription: "",
      piecesPerBuom: "",
      productPrice: null,
    },
  ]);

  const [finishing, setFinishing] = useState([
    {
      finishingCode: "",
      finishingName: "",
    },
  ]);

  const initialData = [
    [
      "cr1215",
      "Chocolate Rugalech",
      "Chocolate Rugalech",
      "10",
      "lb",
      "$5.99",
      "$59.90",
    ],
    [
      "cr1215",
      "Chocolate Rugalech",
      "Chocolate Rugalech",
      "10",
      "lb",
      "$5.99",
      "$59.90",
      "fdgdfg",
    ],
  ];

  const [data, setData] = useState(initialData);

  const columns = [
    "Product Ref",
    "Name",
    "Description",
    "Quantity",
    "Unit",
    {
      name: "Price Per Unit",
      options: {
        filter: true,
        sort: false,
        empty: false,
        customBodyRender: (valu, tableMeta, update) =>
          tableMeta.rowIndex === value ? (
            <input value={valu} onChange={(e) => update(e.target.value)} />
          ) : (
            <Typography>{valu}</Typography>
          ),
      },
    },
    {
      name: "Total Price",
      options: {
        filter: true,
        sort: false,
        empty: false,
        customBodyRender: (valu, tableMeta, update) =>
          tableMeta.rowIndex === value ? (
            <input value={valu} onChange={(e) => update(e.target.value)} />
          ) : (
            <Typography>{valu}</Typography>
          ),
      },
    },
    {
      name: "Edit",
      options: {
        filter: true,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, update) => (
          <button onClick={() => setValue(tableMeta.rowIndex)}>edit</button>
        ),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    responsive: "scrollMaxHeight",
    customToolbar: () => {
      return (
        <Tooltip title="Add Product">
          <IconButton
            onClick={() =>
              setData((data) => [...data, ["", "", "", "", "", "", ""]])
            }
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    },
  };

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      const copyState = { ...baseProduct };

      copyState.sizes.push(event.target.value);

      setBaseProduct(copyState);
      setSizeValue("");
    }
  }

  function handleDeleteChip(index) {
    const copyState = { ...baseProduct };

    copyState.sizes.splice(index, 1);

    setBaseProduct(copyState);
  }

  const steps = [
    {
      stepName: "Base Product",
      handleNext: () => console.log("add new product"),
      step: (
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            height: "100%",
            marginTop: "10px",
          }}
        >
          {/* <Typography sx={{ margin: "10px" }}>Base Product Info</Typography>

          <Divider sx={{ marginBottom: "20px" }} /> */}

          <Box sx={{ display: "flex" }}>
            <TextField
              sx={{ margin: "10px" }}
              value={baseProduct.productCode}
              key="1"
              onChange={(e) =>
                setBaseProduct((product) => {
                  const copyState = { ...product };

                  copyState.productCode = e.target.value;

                  return copyState;
                })
              }
              label="Code"
              color="primary"
            />

            <TextField
              sx={{ margin: "10px", width: "250px", paddingTop: "auto" }}
              value={baseProduct.productName}
              onChange={(e) =>
                setBaseProduct((product) => {
                  const copyState = { ...product };

                  copyState.productName = e.target.value;

                  return copyState;
                })
              }
              label="Name"
              color="primary"
            />
            <TextField
              sx={{ margin: "10px" }}
              value={baseProduct.productDescription}
              onChange={(e) =>
                setBaseProduct((product) => {
                  const copyState = { ...product };

                  copyState.productDescription = e.target.value;

                  return copyState;
                })
              }
              label="Description"
              color="primary"
            />

            <TextField
              sx={{ margin: "10px" }}
              value={baseProduct.productUnitOfMeasure}
              onChange={(e) =>
                setBaseProduct((product) => {
                  const copyState = { ...product };

                  copyState.productUnitOfMeasure = e.target.value;

                  return copyState;
                })
              }
              label="Bakery Unit Of Measure"
              color="primary"
            />
          </Box>
        </Paper>
      ),
    },
    {
      stepName: "Packaging",

      step: (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            // width: "100%",
          }}
        >
          <DialogSave />
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              // width: "100%",
              height: "100%",
              overflow: "auto",
            }}
          >
            {/* <FullFeaturedCrudGrid columns={columnsDataGrid} rows={rows} /> */}
            {/* <Typography sx={{ margin: "10px" }}></Typography>
            <Divider sx={{ marginBottom: "20px" }} /> */}

            {packaging.map((item, index) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                }}
                key={index}
              >
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.productCode}
                  onChange={(e) =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].productCode = e.target.value;

                      return newPackage;
                    })
                  }
                  label="Package Code"
                  color="primary"
                />
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.productName}
                  onChange={(e) =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].productName = e.target.value;

                      return newPackage;
                    })
                  }
                  label="Package Name"
                  color="primary"
                />
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.productCategory}
                  onChange={(e) =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].productCategory = e.target.value;

                      return newPackage;
                    })
                  }
                  label="Package Category"
                  color="primary"
                />
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.piecesPerBuom}
                  type="number"
                  step="0.01"
                  onChange={(e) =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].piecesPerBuom = parseFloat(
                        e.target.value,
                      );

                      return newPackage;
                    })
                  }
                  label="Pieces per BUOM"
                  color="primary"
                />

                <TextField
                  sx={{ margin: "10px" }}
                  value={item.productPrice}
                  type="number"
                  step="0.01"
                  onChange={(e) =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].productPrice = Number(e.target.value);

                      return newPackage;
                    })
                  }
                  label="Price"
                  color="primary"
                />

                <DeleteIcon
                  fontSize="large"
                  onClick={() =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      // console.log(newPackage);
                      newPackage.splice(index, 1);

                      return newPackage;
                    })
                  }
                />
              </Box>
            ))}

            <Button
              variant="contained"
              sx={{
                marginLeft: "20px",
                marginTop: "10px",
                marginBottom: "20px",
                marginRight: "auto",
              }}
              onClick={() =>
                setPackaging((pkg) => [
                  ...pkg,
                  {
                    productCode: "",
                    productName: "",
                    productDescription: "",
                    piecesPerBuom: "",
                    productPrice: null,
                    productCategory: "",
                  },
                ])
              }
            >
              New Package
            </Button>
          </Paper>
        </Box>
      ),
    },
    {
      stepName: "Finishing",
      step: (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflow: "auto",
            }}
          >
            {/* <FullFeaturedCrudGrid columns={columnsDataGrid} rows={rows} /> */}
            {/* <Typography sx={{ margin: "10px" }}></Typography>
            <Divider sx={{ marginBottom: "20px" }} /> */}

            {finishing.map((item, index) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                }}
                key={index}
              >
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.finishingCode}
                  onChange={(e) =>
                    setFinishing((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].finishingCode = e.target.value;

                      return newPackage;
                    })
                  }
                  label="Finishing Code"
                  color="primary"
                />
                <TextField
                  sx={{ margin: "10px" }}
                  value={item.finishingName}
                  onChange={(e) =>
                    setFinishing((pkg) => {
                      const newPackage = [...pkg];

                      newPackage[index].finishingName = e.target.value;

                      return newPackage;
                    })
                  }
                  label="Finishing Name"
                  color="primary"
                />

                <DeleteIcon
                  fontSize="large"
                  onClick={() =>
                    setPackaging((pkg) => {
                      const newPackage = [...pkg];

                      // console.log(newPackage);
                      newPackage.splice(index, 1);

                      return newPackage;
                    })
                  }
                />
              </Box>
            ))}

            <Button
              variant="contained"
              sx={{
                marginLeft: "20px",
                marginTop: "10px",
                marginBottom: "20px",
                marginRight: "auto",
              }}
              onClick={() =>
                setFinishing((pkg) => [
                  ...pkg,
                  {
                    finishingCode: "",
                    finishingName: "",
                  },
                ])
              }
            >
              New Finishing
            </Button>
          </Paper>
        </Box>
      ),
    },
  ];

  const steperOptions = {
    handleFineshed: () => {
      fetchGraphql({
        query: `mutation CreateProduct($product: ProductInput) {createProduct(product: $product)}`,
        variables: { product: baseProduct },
      }).then((result) => {
        navigate(`/products/product/${result.data.createProduct}/base-product`);
        fetchGraphql({
          query: `mutation CreateProducts($productId: ID, $product: [ProductInput]) {createProducts(productId: $productId, product: $product)}`,
          variables: {
            productId: result.data.createProduct,
            product: packaging,
          },
        });
        fetchGraphql({
          query: `mutation CreateFinishings($productId: ID, $finishing: [FinishingInput]) {
            createFinishings(productId: $productId, finishing: $finishing)
          }`,
          variables: { productId: result.data.createProduct, finishing },
        });
      });
    },
  };

  return (
    <Box sx={{ minHeight: "300px", padding: "25px", height: "87%" }}>
      <HorizontalLinearStepper steps={steps} options={steperOptions} />
      {/* <h1>New Product</h1> */}
    </Box>
  );
}
